import React, { useState } from "react";
import SectionHeading from "@components/sectionHeading";
import CheckBox from "@components/checkBox";
import ReferralForm from "../../PersonalLoan/containers/ReferralForm/referralForm";
import Button from "@components/button";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { palette } from "styled-theme";
import { useOnMount } from "@hooks";
import actions from "@redux/startup/actions";
import useGtmPageEvent from "@hooks/useGtmPageEvent";
import { themes } from "@src/theme/config";
import { ReferralFormWrapper } from "./ReferralFormWrapper.styles";

const checkForNewLoanFormState = ({ loanFormResponse }) =>
  loanFormResponse === null;

const useConditionalRehydration = () => {
  const loanFormState = useSelector((state) => state.loanForm);
  const dispatch = useDispatch();

  useOnMount(() => {
    if (checkForNewLoanFormState(loanFormState)) {
      dispatch(actions.fillForm());
    }
  });
};

const getFormValue = ({ loanFormResponse, initialValue }) => {
  return loanFormResponse != null
    ? { ...loanFormResponse.value }
    : initialValue;
};

const LightBackground = styled.div`
  background: ${palette("referralBackground", 0)};

  width: 100%;
`;

export const Decline = () => {
  useConditionalRehydration();
  useGtmPageEvent();
  const themeName = useSelector(state => state.StartUp.theme.themeName);
  const loanFormState = useSelector((state) => state.loanForm);
  const formValue = getFormValue(loanFormState);
  const { firstName, referralConsent } = formValue;

  const [hasReferralConsent, setReferralConsent] = useState(
    !!formValue.referralConsent
  );
  const [neededConsentOnMount] = useState(referralConsent !== true);

  const handleCheckBox = () => {
    setReferralConsent(!hasReferralConsent);
  };

  let headingText = "We're sorry...";
  if (firstName) {
    headingText = `Hi ${firstName}`;
  }

  return (
    <>
      <SectionHeading
        heading={headingText}
        className="margin-bottom capitalise"
        soft
        subheading={
          <>
            Unfortunately we are unable to help you at this time. <br />
            If you wish, we can refer your details to another lender whose
            criteria may be more suitable.
          </>
        }
      />
      {neededConsentOnMount &&
        themeName !== themes.fgfParent.loanOptions.themeName && (
          <div>
            <SectionHeading
              className="secondary-header"
              soft
              heading="To proceed, please confirm your information below and click continue"
            />
            <label>
              <CheckBox
                onChange={handleCheckBox}
                checked={hasReferralConsent}
                name="referralConsent"
              >
                <strong>Referral Consent</strong> : Given we are unable to offer
                a loan today, we may be able to refer you to other credit
                providers and alternative service providers as described in our
                Privacy Policies, who may be able to offer you an alternative
                finance option (including a line of credit, unsecured personal
                loan or vehicle loan). Do you give us approval to do this and
                agree to sending your contact details, name and financial
                information to these providers?
              </CheckBox>
            </label>
          </div>
        )}
      {themeName !== themes.fgfParent.loanOptions.themeName && (
          <ReferralFormWrapper checked={hasReferralConsent}>
            <LightBackground className="margin-bottom">
              <ReferralForm values={formValue} />
            </LightBackground>
          </ReferralFormWrapper>
        )}
      <SectionHeading
        heading="You can also access your free credit file through Equifax"
        subheading="Access your free credit file through Equifax, to check your credit score and confirm your details are correct."
        className="margin-bottom-small secondary-header"
        soft
      />
      <Button
        elementType="a"
        href="https://www.veda.com.au/"
        rel="noopener noreferrer"
        className="margin-bottom"
      >
        GET MY CREDIT FILE
      </Button>
    </>
  );
};
